import React, { ReactNode, Suspense } from 'react';

import { Spinner } from '../icons/spinner';

/**
 * This component is a boiler plate for lazy loading routes.
 * See src/routes/content/index.tsx for usage.
 * Once we are able to upgrade to react-router v6.9.0+, we can remove this component.
 */
export const LazyRoute = ({ children }: { children: ReactNode }) => {
  return <Suspense fallback={<RouteLoader />}>{children}</Suspense>;
};

const RouteLoader = () => {
  return (
    <div className="flex w-full justify-center items-center h-full py-8">
      <Spinner size="large" className="text-blue-500" showLabel />
    </div>
  );
};
